<template>
  <div class="stock-wrapper">
    <div class="section-title">
      <div class="left">
        <div>
          <i class="el-icon-shopping-cart-1"></i>
          <span class="title-name">库存查询</span>
          <br />
          <span class="title-desc">{{ sortText }}</span>
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="stock-table-wrapper comon-table-style">
      <div class="table-tool-box">
        <div class="tool-item">
          <span class="tool-label">产品系列:</span>
          <span class="tool-content">
            <el-select
              v-model="tableFilters.series"
              style="width: 100%"
              filterable
              clearable
              placeholder="产品系列"
              @change="seriesChange"
            >
              <template v-for="(ser, index) in seriesGroup">
                <el-option
                  :label="ser.label"
                  :value="ser.value"
                  :key="index"
                ></el-option>
              </template>
            </el-select>
          </span>
        </div>

        <div class="tool-item">
          <span class="tool-label">产品规格:</span>
          <span class="tool-content">
            <el-select
              v-model="tableFilters.specification"
              style="width: 100%"
              filterable
              clearable
              placeholder="产品规格"
              @change="specificationChange"
            >
              <template v-for="(item, index) in specificationGroup">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </template>
            </el-select>
          </span>
        </div>

        <div class="tool-item">
          <span class="tool-label">产品简码:</span>
          <span class="tool-content">
            <el-select
              v-model="tableFilters.simpleCode"
              style="width: 100%"
              filterable
              clearable
              placeholder="产品简码"
              @change="simpleCodeChange"
            >
              <template v-for="(ser, index) in simpleCodeGroup">
                <el-option
                  :label="ser.label"
                  :value="ser.value"
                  :key="index"
                ></el-option>
              </template>
            </el-select>
          </span>
        </div>
      </div>
      <!-- class="hidden-sm-and-down" -->
      <pcTable
        :sortedBy="sortedBy"
        :listDirection="listDirection"
        :tableData="tableData"
        :tableLoading="tableLoading"
        @onChange="onTableSortChange"
      />
      <!-- <mobileTable :tableData="tableData" :tableLoading="tableLoading" class="hidden-md-and-up"/> -->

      <div class="pagenation-wrapper">
        <!-- pc端显示 -->
        <el-pagination
          class="pagenation hidden-xs-only"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 40, 60, 80]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSizes"
        ></el-pagination>
        <!-- 移动端显示 -->
        <el-pagination
          class="pagenation pagenation-samll hidden-md-only"
          small
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="totalSizes"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pcTable from "./components/pc";
import mobileTable from "./components/mobile";
import { mapMutations } from "vuex";
import qs from "qs";
import { getOrderNameCn, getOrderType } from "@/utils/app";
export default {
  name: "stock",
  components: {
    pcTable,
    mobileTable,
  },
  data() {
    return {
      tableLoading: false,
      size: 10,
      page: 0,
      totalPages: 0,
      totalSizes: 0,
      tableData: [],
      simpleCode: "",
      sortedBy: "seriesSequence,ASC",
      sortText: `按照默认倒序排序`,
      listDirection: "descending",
      tableFilters: {
        simpleCode: "",
        series: "",
        specification: ""
      },
      simpleCodeGroup: [],
      seriesGroup: [],
      specificationGroup: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.app.isMobileMode;
    },
  },
  created() {
    this.getTableData();
    this.getfilterOptions();
  },
  watch: {},
  methods: {
    getOrderNameCn,
    getOrderType,
    ...mapMutations({
      ToggleMobileSideBar: "app/ToggleMobileSideBar",
      ToggleToolBar: "app/ToggleToolBar",
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar",
      toggleStockLoading: "stock/toggleStockLoading",
    }),
    dataFilter() {
      return {
        size: this.size,
        page: this.page,
        sort: this.sortedBy,
        simpleCode: this.tableFilters.simpleCode,
        series: this.tableFilters.series,
        specification: this.tableFilters.specification
      };
    },
    getTableData() {
      this.$api
        .get(`/inventories?${qs.stringify(this.dataFilter())}`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.tableData = res.data.content;
            this.totalPages = res.data.totalPages;
            this.totalSizes = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error("库存加载失败", err.response);
        });
    },
    filterOptionParam() {
      if (
        this.tableFilters.simpleCode !== "" ||
        this.tableFilters.series !== "" ||
        this.tableFilters.specification !== ""
      ) {
        this.sortedBy = "simpleCode,ASC";
      } else {
        this.sortedBy = "seriesSequence,ASC";
      }
      return {
        simpleCode: this.tableFilters.simpleCode,
        series: this.tableFilters.series,
        specification: this.tableFilters.specification,
        sort: this.sortedBy,
      };
    },
    onTableSortChange({ column, prop, order }) {
      this.listDirection = order;
      if (order === null) {
        this.sortedBy = "seriesSequence,ASC";
        this.sortText = `按照默认倒序排序`;
      } else {
        this.sortedBy = `${prop},${getOrderType(order)}`;
        this.sortText = `按照 ${this.getSortName(prop)} ${this.getOrderNameCn(
          order
        )} 排序`;
      }
      this.reFresh();
    },
    getSortName(prop) {
      let group = [
        {
          key: "series",
          name: "产品系列",
        },
        {
          key: "simpleCode",
          name: "简码",
        },
        {
          key: "specification",
          name: "规格",
        },
        {
          key: "color",
          name: "色号",
        },
        {
          key: "grade",
          name: "等级",
        },
        {
          key: "pack",
          name: "包装",
        },
        {
          key: "reserveQuantity",
          name: "留货量",
        },
        {
          key: "unitPerPack",
          name: "片/箱",
        },
        {
          key: "quantity",
          name: "可销售量",
        },
        {
          key: "warehouse",
          name: "仓库",
        },
        {
          key: "remark",
          name: "备注",
        }
      ];
      return group.find((item) => item.key == prop).name;
    },
    // 获取分类列表
    getfilterOptions() {
      this.$api
        .get(`/inventories/filter?${qs.stringify(this.filterOptionParam())}`)
        .then((res) => {
          // this.$api.get(`/inventories/filter`).then(res=>{
          if (res.status === 200 || res.status === 206) {
            let tampSeries = [];
            let tampSpecifications = [];
            let tampSimpleCodes = [];
            res.data.series.forEach((serie) => {
              tampSeries.push({
                label: serie,
                value: serie,
              });
            });
            res.data.simpleCodes.forEach((item) => {
              tampSimpleCodes.push({
                label: item,
                value: item,
              });
            });
            res.data.specifications.forEach((item) => {
              tampSpecifications.push({
                label: item,
                value: item,
              });
            });
            this.simpleCodeGroup = tampSimpleCodes;
            this.seriesGroup = tampSeries;
            this.specificationGroup = tampSpecifications;
          }
        });
    },
    simpleCodeChange(val) {
      this.page = 0;
      this.tableFilters.simpleCode = val ? val : "";
      this.getTableData();
      this.getfilterOptions();
    },
    seriesChange(val) {
      this.page = 0;
      this.tableFilters.series = val ? val : "";
      this.getTableData();
      this.getfilterOptions();
    },
    specificationChange(val) {
      this.page = 0;
      this.tableFilters.specification = val ? val : "";
      this.getTableData();
      this.getfilterOptions();
    },
    handleSizeChange(size) {
      this.page = 0;
      this.size = size ? size : this.size;
      this.getTableData();
    },
    handleCurrentChange(Cpage) {
      this.page = Cpage ? Cpage - 1 : 0;
      this.getTableData();
    },
    reFresh() {
      this.page = 0;
      this.getTableData();
    },
    clearAllFilter() {
      this.tableFilters.series = "";
      this.tableFilters.specification = "";
      this.tableFilters.simpleCode = "";
      this.getTableData();
      this.getfilterOptions();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.stock-wrapper {
  .stock-table-wrapper {
    box-sizing: border-box;
    padding-top: 30px;
    .stock-table {
      border: 1px solid #dbdbdb;
    }
    .table-tool-box {
      box-sizing: border-box;
      position: relative;
      margin-top: 0;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .tool-item {
        box-sizing: border-box;
        padding: 0 10px 0 0;
        flex: 1;
        max-width: 300px;
        display: flex;
        text-align: left;
        line-height: 40px;
        box-sizing: border-box;
        font-size: 0;
        &:last-child {
          padding: 0;
        }
        .tool-label {
          flex: 60px 0 0;
          width: 60px;
          text-align: left;
          font-size: 14px;
          font-weight: 450;
          color: #333;
          margin-right: 8px;
        }
        .tool-content {
          flex: 1;
          font-size: 14px;
          color: #333;
        }
      }
      .table-search {
        position: absolute;
        right: 0;
        bottom: 2px;
        width: 50px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        color: #242424;
        border: 1px solid #929292;
        display: inline-block;
        transition: all 0.3s linear;
        &:hover {
          background-color: $theme_color;
          border: 1px solid $theme_color;
          color: #242424;
          cursor: pointer;
        }
      }
    }
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: left;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    .left {
      flex: 1;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .right {
      flex: auto;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
    .title-desc {
      font-size: 14px;
      color: #989898;
    }
  }
}
@media screen and(max-width:992px) {
  .stock-wrapper {
    padding: 0px 0px 20px 0px;
    .right {
      .stock-table-wrapper {
        padding: 0;
      }
      .pagenation-wrapper {
        border-color: transparent;
      }
    }
    .table-tool-box {
      display: block;
      .tool-item {
        width: 100%;
        padding: 10px 0;
        .tool-label {
          display: block;
          margin-bottom: 5px;
          color: #fff;
          text-align: left;
        }
        .tool-content {
          display: block;
          font-size: 14px;
          color: #333;
          .el-select {
            width: 100%;
          }
        }
      }
      .table-search {
        width: 100%;
        height: 35px;
        line-height: 35px;
        font-size: 15px;
        text-align: center;
        color: #333;
        background-color: $theme_color;
        display: block;
        margin-top: 12px;
        transition: all 0.3s linear;
      }
      .table-clear {
        color: $theme_color;
        border: 1px solid $theme_color;
        height: 35px;
        line-height: 35px;
        margin-top: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.stock-wrapper {
  .table-tool-box {
    .el-input__inner {
      border: none;
      border-radius: 0px;
    }
  }
  .pagenation-wrapper {
    // 页码列表的前后的按钮
    .el-pagination button {
      background-color: transparent;
    }
    .el-pagination button:disabled {
      background-color: transparent;
    }
    .el-pagination button:hover {
      color: #fff;
      background-color: #4c4948;
    }
    // 可选的页码列表
    .el-pager li {
      background-color: transparent;
    }
    .el-pager li:hover {
      color: #fff;
      background-color: #4c4948;
    }
    .el-pager li.active {
      color: #fff;
      background-color: #4c4948;
      cursor: default;
    }
    // 手动输入页数的输入框
    .el-pagination__editor.el-input .el-input__inner {
      background-color: transparent;
    }
    // 选择多少条每页的按钮
    .el-pagination .el-select .el-input .el-input__inner {
      background-color: transparent;
    }
  }
}
</style>



